import { lazy } from 'react';
/** Открывает список политик */
export const PoliciesPageAsync = lazy(() => import('./Policies/PoliciesPage'));